export default function NextStepButton({children, disabled = false}) {
    return (
        <>
            <div className='actions'>
                <button className='btn btn--yellow goto-next-step' type='submit' disabled={disabled}>{children}</button>
            </div>
            <style jsx>
                {`
                    @import '@css/variables.css';

                    .actions {
                        text-align: right;
                        margin-top: 10px;
                        padding-top: 20px;
                        border-top: 1px solid $c--blue--light-gray;
                    }
                `}
            </style>
        </>
    )
}
